module.exports = __webpack_public_path__ + "static/media/error-x.e1ab3d7a.png";